import React from 'react';
import PropTypes from 'prop-types';
const TabGroup = ({ label, children }) => (React.createElement("div", { className: "tab-group" },
    React.createElement("h6", null, label),
    children));
TabGroup.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node,
};
export default TabGroup;
